import { useTheme } from "@mui/material"

export const useStylesPatient = () => {
    const { breakpoints } = useTheme()
    return {
        styles: {
            addObservation: {
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "16px"
            },
            buttonsContainer: {
                display: "flex",
                alignItems: 'center',
                gap: '5px',
                marginLeft: '8px',
                [breakpoints.down('md')]: {
                    marginLeft: 0,
                    width: '100%',
                },
            },
            buttons: {
                '&.MuiButton-root': {
                    height: '56px',
                    borderRadius: 0,
                    textTransform: 'none',
                    boxShadow: 'none',
                    whiteSpace: 'nowrap',
                    [breakpoints.down('md')]: {
                        width: '50%',
                    },
                }
            },
            search: {
                width: "250px",
                maxWidth: "250px",
                marginLeft: "8px",
                [breakpoints.down('lg')]: {
                    width: 'calc(40% - 15px)',
                    maxWidth: "100%",
                    marginLeft: "0px",
                },
                [breakpoints.down('md')]: {
                    width: '100%',
                    marginLeft: 0,
                },
                '& .MuiOutlinedInput-input': {
                    padding: "15px 14px"
                },
                '& .MuiInputBase-root.MuiOutlinedInput-root': {
                    // color: colors.greyPlaceholder
                }
            }
        }
    }
}